import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { BrMaskerModule } from "brmasker-ionic-3";
import { IonicPageModule } from "ionic-angular";
import { TruncateModule } from "ng2-truncate";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { ComponentsModule } from "../../../components/components.module";
import { CompanyAddLocation } from "../company-details/add-location/company-add-location";
import { CompanyDetails } from "../company-details/company-details";
import { CompanyDetailsLocationGroups } from "../company-details/companyLocations/company-details-companyLocations";
import { CompanyDetailsContacts } from "../company-details/contacts/company-details-contacts";
import { CompanyDetailsDetails } from "../company-details/details/company-details-details";
import { CompanyDetailsFacilities } from "../company-details/facilitities/company-details-facilities";
import { WorkGroupsList } from "../company-details/workgroup-management/work-groups-list";
import { CompanyPageModule } from "../company.module";
import { CompanyDetailsPage } from "./locations";

@NgModule({
  declarations: [
    CompanyDetailsPage,
    CompanyDetails,
    CompanyDetailsFacilities,
    CompanyDetailsDetails,
    CompanyDetailsContacts,
    CompanyDetailsLocationGroups,
    WorkGroupsList,
    CompanyAddLocation,
  ],
  imports: [
    CommonComponentsModule,
    IonicPageModule.forChild(CompanyDetailsPage),
    TranslateModule,
    ComponentsModule,
    CompanyPageModule,
    TruncateModule,
    NgSelectModule,
  ],
  exports: [
    BrMaskerModule,
    CompanyDetailsFacilities,
    CompanyAddLocation,
    WorkGroupsList,
  ],
})
export class CompanyDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/company/locations/locations.module.ts